export default [
  'Svg',
  'SvgCircle',
  'SvgEllipse',
  'SvgDefs',
  'SvgGroup',
  'SvgLinearGradient',
  'SvgRadialGradient',
  'SvgLine',
  'SvgPath',
  'SvgPolygon',
  'SvgPolyline',
  'SvgRect',
  'SvgSymbol',
  'SvgText',
  'SvgUse',
  'SvgDefs',
  'SvgStop',
]
